import React, { useState, useEffect, useCallback } from 'react'
import {
  ModalHeader,
  ModalDescription,
  ModalContent,
  ModalActions,
  Button,
  Modal,
  Form,
  FormField,
  Checkbox,
} from 'semantic-ui-react'
import { toast } from 'react-toastify'

import api from '../../../../services/api'

export default function ModalConfigDomain({
  openModalConfigDomain,
  setOpenModalConfigDomain,
  selectDomain,
}) {
  const [domainConfig, setDomainConfig] = useState({})

  const [exportTicketComments, setExportTicketComments] = useState(false)
  const [exportTicketRemoveDomain, setExportTicketRemoveDomain] =
    useState(false)
  const [exportTicketIncludeCallid, setExportTicketIncludeCallid] =
    useState(false)
  const [validateWhatsappNumber, setValidateWhatsappNumber] = useState(false)

  const getDomainConfig = useCallback(() => {
    if (selectDomain) {
      api.get(`/domains/${selectDomain}`).then((response) => {
        setDomainConfig(response.data)
        setExportTicketComments(response.data.export_ticket_comments || false)
        setExportTicketRemoveDomain(
          response.data.export_ticket_remove_domain || false,
        )
        setExportTicketIncludeCallid(
          response.data.export_ticket_include_callid || false,
        )
        setValidateWhatsappNumber(
          response.data.validate_whatsapp_number || false,
        )
      })
    }
  }, [selectDomain])

  useEffect(() => {
    getDomainConfig()
  }, [getDomainConfig])

  const handleUpdateDomainConfig = useCallback(async () => {
    const updatedConfig = {
      export_ticket_comments: exportTicketComments,
      export_ticket_remove_domain: exportTicketRemoveDomain,
      export_ticket_include_callid: exportTicketIncludeCallid,
      validate_whatsapp_number: validateWhatsappNumber,
    }

    await api.put(`/domains/${selectDomain}`, updatedConfig)
    toast.success('Configuração do domínio atualizada com sucesso!')
    getDomainConfig()
    setOpenModalConfigDomain(false)
  }, [
    exportTicketComments,
    exportTicketRemoveDomain,
    exportTicketIncludeCallid,
    validateWhatsappNumber,
    selectDomain,
    setOpenModalConfigDomain,
    getDomainConfig,
  ])

  return (
    <Modal
      onClose={() => setOpenModalConfigDomain(false)}
      onOpen={() => setOpenModalConfigDomain(true)}
      open={openModalConfigDomain}
      trigger={<Button>Show Modal</Button>}
    >
      <ModalHeader>Gerenciar Domínio</ModalHeader>
      <ModalContent>
        {/* <pre>{JSON.stringify(domainConfig, null, 2)}</pre> */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <strong style={{ textAlign: 'center' }}>
            {domainConfig.dominio}
          </strong>
        </div>

        <Form>
          <FormField>
            <Checkbox
              label="Comentários ao exportar chamados"
              defaultChecked={exportTicketComments}
              onChange={() => setExportTicketComments(!exportTicketComments)}
            />
          </FormField>
          <FormField>
            <Checkbox
              label="Remover dominio ao exportar chamados"
              defaultChecked={exportTicketRemoveDomain}
              onChange={() =>
                setExportTicketRemoveDomain(!exportTicketRemoveDomain)
              }
            />
          </FormField>
          <FormField>
            <Checkbox
              label="Incluir CallID do SBC ao exportar chamados"
              defaultChecked={exportTicketIncludeCallid}
              onChange={() =>
                setExportTicketIncludeCallid(!exportTicketIncludeCallid)
              }
            />
          </FormField>
          <FormField>
            <Checkbox
              label="Validar se originador é whatsapp (requer Evolution API)"
              defaultChecked={validateWhatsappNumber}
              onChange={() =>
                setValidateWhatsappNumber(!validateWhatsappNumber)
              }
            />
          </FormField>
        </Form>
      </ModalContent>
      <ModalActions>
        <Button color="black" onClick={() => setOpenModalConfigDomain(false)}>
          Fechar
        </Button>
        <Button
          content="Atualizar"
          labelPosition="right"
          icon="save"
          onClick={() => handleUpdateDomainConfig()}
          color="blue"
        />
      </ModalActions>
    </Modal>
  )
}
